import React, { useState, useEffect } from "react";

import { AppSettings } from "../../constant";
import { toast } from "react-toastify";
import { NavLink } from "react-router-dom";
import Select from "react-dropdown-select";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import Tooltip from "@mui/material/Tooltip";
import ViewAsset from "./viewAsset";
import axiosInstance from "../../axios-interceptor";
import { getAllDepartments, getAllDesignations } from "../../services/master-managementservice";
import ATImage from "../assets/images/AT.png";
import DTImage from "../assets/images/DT.png";
import LTImage from "../assets/images/LT.png";
import MTImage from "../assets/images/MT.png";
import NTImage from "../assets/images/NT.png";
import NoDataFoundImage from "../assets/images/no-data-found.svg";

const NAME_REGEX = /^[A-Za-z0-9]+(?: [A-Za-z0-9]+)*$/;
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.com$/i;

function validateNameField(value, fieldLabel) {
  if (!value) return `${fieldLabel} is required`;
  if (/^\s/.test(value)) return `${fieldLabel} cannot start with a space`;

  const trimmed = value.trim();
  if (!trimmed) return `${fieldLabel} is required`;
  if (trimmed.length < 2 || trimmed.length > 50) {
    return `${fieldLabel} must be between 2 and 50 characters`;
  }
  if (!NAME_REGEX.test(trimmed)) {
    return `Please enter valid ${fieldLabel}`;
  }
  return "";
}

function validateEmailField(value) {
  const trimmed = value?.trim() || "";
  if (!trimmed) return "Email is required";
  if (!EMAIL_REGEX.test(trimmed)) {
    return "Please enter valid email";
  }
  return "";
}

function formatNameInput(val) {
  if (val.length > 0) {
    val = val.charAt(0).toUpperCase() + val.slice(1);
  }
  val = val.replace(/ {2,}/g, " ");
  return val.slice(0, 50);
}

function collapseSpaces(val) {
  val = val.replace(/ {2,}/g, " ");
  return val.slice(0, 50);
}

function UserManagement() {
  const [data, setData] = useState([]);
  const customId = "custom-id-yes";
  const [currentPage, setCurrentPage] = useState(1);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [sidebarAction, setSidebarAction] = useState("");
  const [inputValues, setInputValues] = useState({});
  const [loading, setLoading] = useState(false);
  const [editItemId, setEditItemId] = useState(null);
  const [dataError, setDataError] = useState({
    empid: false,
    username: false,
    designation: false,
    department: false,
    email: false,
  });
  const [selectedValue, setSelectedValue] = useState({
    empid: { value: "", label: "" },
    username: { value: null, label: "" },
    designation: { value: null, label: "" },
    department: { value: null, label: "" },
    email: { value: null, label: "" },
  });

  const [searchFilter, setSearchFilter] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [showFilterPanel, setShowFilterPanel] = useState(false);
  const [filterValue, setFilterValue] = useState({
    department: { value: null, label: "" },
    designation: { value: null, label: "" },
  });
  const [filterDropdowns, setFilterDropdowns] = useState({
    departments: [],
    designations: [],
  });

  //To get all Users
  const getUsers = async (dept, desig) => {
    try {
      const params = {};
      if (dept) params.department = dept;
      if (desig) params.designation = desig;

      const res = await axiosInstance.get(AppSettings.URLs.getAllUsers, { params });
      if (res != null) {
        setData(res?.data?.response?.users);
        setFilteredData(res?.data?.response?.users);
        setLoading(true);
        setSearchFilter("");
      }
    } catch (err) {
      console.log(err.message);
    }
  };

  const fetchFilterDropdowns = async () => {
    try {
      const [departments, designations] = await Promise.all([
        getAllDepartments(),
        getAllDesignations(),
      ]);
      setFilterDropdowns({ departments, designations });
    } catch (err) {
      console.log(err);
    }
  };


  useEffect(() => {
    getUsers();
    fetchFilterDropdowns();
  }, []);

  useEffect(() => {
    if (isSidebarOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isSidebarOpen]);

  const handleInputChange = (e, name) => {
    let value;
    if (e && e.target) {

      value = e?.target?.value;

      if (name === "username") {
        value = formatNameInput(value);
      } else if (name === "empid") {
        value = collapseSpaces(value);
      }

      setSelectedValue((option) => ({
        ...option,
        [name]: { value: null, label: value },
      }));
    } else {

      value = e ? e[0]?.value : "";
      setSelectedValue((option) => ({
        ...option,
        [name]: { value: e ? e[0]?.value : "", label: e ? e[0]?.label : "" },
      }));
    }
    setInputValues((prevInputValues) => ({
      ...prevInputValues,
      [name]: value,
    }));
  };

  //To Open sideBar
  const handleSidebarOpen = (action, item) => {
    setIsSidebarOpen(true);
    setSidebarAction(action);
    setInputValues(item);
    setEditItemId(item?.id);
    if (item !== null) {
      setSelectedValue({
        empid: { value: item?.empid, label: item?.empid },
        username: { value: item?.username, label: item?.username },
        designation: { value: item?.designation, label: item?.designation },
        department: { value: item?.department, label: item?.department },
        email: { value: item?.email, label: item?.email },
      });
    } else {
      setSelectedValue({
        empid: { value: "", label: "" },
        username: { value: null, label: "" },
        designation: { value: null, label: "" },
        department: { value: null, label: "" },
        email: { value: null, label: "" },
      });
    }
  };

  //To Close SideBar
  const handleSidebarClose = () => {
    setIsSidebarOpen(false);
    setSidebarAction("");
    setEditItemId(null);
    setInputValues({});
    setSelectedValue({
      empid: { value: "", label: "" },
      username: { value: null, label: "" },
      designation: { value: null, label: "" },
      department: { value: null, label: "Department" },
      email: { value: null, label: "" },
    });
    setDataError({
      empid: false,
      username: false,
      designation: false,
      department: false,
      email: false,
    });
  };

  //To handle submit action of Sidebar
  const handleSidebarFormSubmit = (event) => {
    let isFormFilled = false;
    setDataError({
      empid:
        inputValues?.empid === undefined || inputValues?.empid === ""
          ? true
          : false,
      username:
        inputValues?.username === undefined || inputValues?.username === ""
          ? true
          : false,
      designation:
        inputValues?.designation === undefined ||
          inputValues?.designation === ""
          ? true
          : false,
      department:
        inputValues?.department === undefined || inputValues?.department === ""
          ? true
          : false,
      email:
        inputValues?.email === undefined || inputValues?.email === ""
          ? true
          : false,
    });

    const usernameMsg = inputValues?.username
      ? validateNameField(inputValues.username, "Employee name")
      : "";
    const emailMsg = inputValues?.email
      ? validateEmailField(inputValues.email)
      : "";

    if (usernameMsg || emailMsg) {
      setDataError((prev) => ({
        ...prev,
        username: usernameMsg ? true : prev.username,
        email: emailMsg ? true : prev.email,
      }));
      toast.error(usernameMsg || emailMsg, { toastId: customId });
      return;
    }

    if (
      inputValues?.empid !== undefined &&
      inputValues?.empid !== "" &&
      inputValues?.username !== undefined &&
      inputValues?.username !== "" &&
      inputValues?.designation !== undefined &&
      inputValues?.designation !== "" &&
      inputValues?.department !== undefined &&
      inputValues?.department !== "" &&
      inputValues?.email !== undefined &&
      inputValues?.email !== ""
    ) {
      isFormFilled = true;
    }

    if (isFormFilled === true) {
      if (sidebarAction === "add") {
        const selectedUser = data?.find(
          (item) => item.empid === inputValues.empid
        );
        if (
          inputValues.empid === selectedUser?.empid ||
          !inputValues?.empid?.toLowerCase().startsWith("sys-") ||
          inputValues?.empid === "sys-"
        ) {
          setDataError((prev) => ({
            ...prev,
            empid: true,
          }));
          if (inputValues.empid.toLowerCase() === selectedUser?.empid.toLowerCase()) {
            toast.error("Employee ID already exists", {
              toastId: customId,
            });
          } else {
            toast.error("Please enter valid employee id", {
              toastId: customId,
            });
          }
        }

        if (/\d/.test(inputValues?.username)) {
          setDataError((prev) => ({
            ...prev,
            username: true,
          }));
          toast.error("Employee name can't contains no", {
            toastId: customId,
          });
        }

        if (!inputValues?.email?.includes("@sysfore")) {
          setDataError((prev) => ({
            ...prev,
            email: true,
          }));

          toast.error("Email Id is not valid", {
            toastId: customId,
          });
        }
        if (
          inputValues.empid !== selectedUser?.empid &&
          inputValues?.empid?.toLowerCase().startsWith("sys-") &&
          inputValues?.empid !== "sys-" &&
          !/\d/.test(inputValues?.username) &&
          inputValues?.email?.includes("@sysfore")
        ) {
          axiosInstance
            .post(AppSettings.URLs.addUser, inputValues)
            .then((res) => {
              const statusCode = res?.data?.statuscode;
              const message = res?.data?.message;

              if (statusCode === 200) {
                toast.success(message || "Submitted Successfully", { toastId: customId });
                getUsers();
                handleSidebarClose();
                setInputValues({});
              } else {
                toast.error(message || "Something went wrong", { toastId: customId });
              }
            })
            .catch((error) => {
              console.log(error);
              toast.error(error?.response?.data?.message || "Something went wrong", {
                toastId: customId,
              });
            });
        }
      } else if (sidebarAction === "edit") {
        axiosInstance
          .post(AppSettings.URLs.updateUser + "?id=" + editItemId, inputValues)
          .then((res) => {
            const statusCode = res?.data?.statuscode;
            const message = res?.data?.message;

            if (statusCode === 200) {
              toast.success(message || "Updated Successfully", { toastId: customId });
              getUsers();
              handleSidebarClose();
              setInputValues({});
            } else {
              toast.error(message || "Something went wrong", { toastId: customId });
            }
          })
          .catch((error) => {
            console.log(error);
            toast.error(error?.response?.data?.message || "Something went wrong", {
              toastId: customId,
            });
          });
      }
    } else {
      toast.error("Please fill all the required fields", {
        toastId: customId,
      });
    }
  };

  const deleteUser = (data) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="react-confirm-alert-body" style={{ position: "relative" }}>
            <button
              type="button"
              onClick={onClose}
              aria-label="Close"
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                width: "32px",
                height: "32px",
                background: "transparent",
                border: "none",
                fontSize: "28px",
                fontWeight: "400",
                lineHeight: "1",
                cursor: "pointer",
                color: "#6c757d",
                opacity: 0.8,
                padding: "0",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
              onMouseEnter={(e) => (e.currentTarget.style.opacity = "1")}
              onMouseLeave={(e) => (e.currentTarget.style.opacity = "0.8")}
            >
              ×
            </button>
            <h1>Delete User</h1>
            {`Are you sure you want to delete user: ${data.username}?`}
            <div className="react-confirm-alert-button-group">
              <button
                onClick={onClose}
              >
                No
              </button>
              <button
                onClick={() => {
                  try {
                    axiosInstance
                      .post(AppSettings.URLs.deleteUser + "?id=" + data.id)
                      .then(() => {
                        getUsers();
                        toast.success("Deleted Successfully", {
                          toastId: customId,
                        });
                      });
                  } catch (error) {
                    console.log(error);
                    toast.error("Something went wrong", {
                      toastId: customId,
                    });
                  }
                  onClose();
                }}
              >
                Yes
              </button>
            </div>
          </div>
        );
      },
    });
  };

  const handleSearch = (value) => {
    if (!value) {
      setFilteredData(data);
    } else {
      const temp = data.filter((object) => {
        for (const key in object) {
          if (object.hasOwnProperty(key) && typeof object[key] === "string") {
            if (object[key].toLowerCase().includes(value.toLowerCase())) return true;
          }
        }
        return false;
      });
      setFilteredData(temp);
      setCurrentPage(1);
    }
  };

  // Asset type helpers
  const assetTypeMap = {
    MT: { label: "Monitor", img: MTImage },
    DT: { label: "Desktop", img: DTImage },
    LT: { label: "Laptop", img: LTImage },
    RE: { label: "Rental Laptop", img: LTImage },
    AT: { label: "Accessory", img: ATImage },
    NT: { label: "Network Device", img: NTImage },
  };

  const getAssetType = (assetId) => {
    if (!assetId || !assetId.includes("F")) return null;
    return assetId.split("F")[1]?.substring(0, 2) || null;
  };

  const renderAssetIcons = (assignedasset) => {
    if (!assignedasset) return <span className="text-gray-400 text-[11px]">—</span>;
    const assets = assignedasset.split(",").filter((a) => a.trim() !== "");
    if (assets.length === 0) return <span className="text-gray-400 text-[11px]">—</span>;

    // Deduplicate by type so one icon per type, tooltip shows all IDs of that type
    const grouped = {};
    assets.forEach((assetId) => {
      const type = getAssetType(assetId.trim());
      const key = type || "__unknown__";
      if (!grouped[key]) grouped[key] = [];
      grouped[key].push(assetId.trim());
    });

    return (
      <div className="flex items-center gap-[14px] flex-nowrap px-1 py-1">
        {Object.entries(grouped).map(([type, ids]) => {
          const assetInfo = assetTypeMap[type];
          const tooltipLabel = assetInfo
            ? `${assetInfo.label}: ${ids.join(", ")}`
            : `Unknown: ${ids.join(", ")}`;
          return (
            <Tooltip key={type} title={tooltipLabel} placement="top" arrow leaveDelay={50}>
              <span className="inline-flex items-center justify-center cursor-default relative mt-[6px] mr-[6px]">
                {assetInfo ? (
                  <img src={assetInfo.img} alt={assetInfo.label} className="h-[26px] w-[26px]" />
                ) : (
                  <span className="text-[10px] text-gray-400">?</span>
                )}
              </span>
            </Tooltip>
          );
        })}
      </div>
    );
  };

  //Pagination
  const itemsPerPage = 10;
  const totalPages = filteredData
    ? Math.ceil(filteredData?.length / itemsPerPage)
    : 0;
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = currentPage * itemsPerPage;
  const displayedData = filteredData
    ? filteredData.slice(startIndex, endIndex)
    : [];
  const goToPreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  };
  const goToNextPage = () => {
    if (endIndex < filteredData?.length) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  };
  const renderPageNumbers = () => {
    const maxPageNumbersToShow = 3; // Adjust this value as per your preference
    const pageNumbers = [];
    let startPage;
    let endPage;

    if (totalPages <= maxPageNumbersToShow) {
      // Show all page numbers if the total pages are less than or equal to the maxPageNumbersToShow
      startPage = 1;
      endPage = totalPages;
    } else {
      // Calculate the start and end page numbers with an ellipsis
      const middlePage = Math.ceil(maxPageNumbersToShow / 2);
      if (currentPage <= middlePage) {
        startPage = 1;
        endPage = maxPageNumbersToShow;
      } else if (currentPage + middlePage - 1 >= totalPages) {
        startPage = totalPages - maxPageNumbersToShow + 1;
        endPage = totalPages;
      } else {
        startPage = currentPage - middlePage + 1;
        endPage = currentPage + middlePage - 1;
      }
    }

    // Add ellipsis at the beginning if needed
    if (startPage > 1) {
      pageNumbers.push(1);
      if (startPage > 2) {
        pageNumbers.push("...");
      }
    }

    // Add page numbers between startPage and endPage
    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(i);
    }

    // Add ellipsis at the end if needed
    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        pageNumbers.push("...");
      }
      pageNumbers.push(totalPages);
    }

    return pageNumbers.map((pageNumber) =>
      typeof pageNumber === "number" ? (
        <li
          key={pageNumber}
          className={`inline-block cursor-pointer hover:backdrop-brightness-90 ${currentPage === pageNumber ? "current" : ""
            }`}
          onClick={() => setCurrentPage(pageNumber)}
        >
          <span>{pageNumber}</span>
        </li>
      ) : (
        <li key={pageNumber} className="inline-block mx-1">
          {pageNumber}
        </li>
      )
    );
  };

  return (
    <>
      <div className="page-titles bg-white px-6 ">
        <div className="flex items-center">
          <div className="mr-4 kr-page-back-btn">
            <NavLink to="/master" className="no-underline">
              <button
                type="button"
                className="btn-primary rounded flex items-center justify-center w-8"
              >
                <svg
                  width={18}
                  className="svg-white"
                  x="0px"
                  y="0px"
                  viewBox="0 0 700 700"
                >
                  <g>
                    <path
                      d="M82.9,331.2l148.3,148.3c7.6,7.6,18.6,10.6,29,7.8c10.4-2.8,18.5-10.9,21.2-21.2c2.8-10.4-0.2-21.4-7.8-29l-97.6-96.9
      h304.7c15.8,0,31,6.3,42.1,17.5c11.2,11.2,17.5,26.3,17.5,42.1v79c0,10.6,5.7,20.5,14.9,25.8c9.2,5.3,20.6,5.3,29.8,0
      c9.2-5.3,14.9-15.2,14.9-25.8v-79c0-31.6-12.6-61.9-34.9-84.3c-22.4-22.4-52.7-34.9-84.3-34.9H176.1l97.6-97.6
      c7.6-7.6,10.6-18.6,7.8-29c-2.8-10.4-10.9-18.5-21.2-21.2c-10.4-2.8-21.4,0.2-29,7.8L82.9,288.7c-5.7,5.6-8.9,13.3-8.9,21.2
      S77.2,325.6,82.9,331.2L82.9,331.2z"
                    ></path>
                  </g>
                </svg>
              </button>
            </NavLink>
          </div>
          <div>
            <h2 className="font-bold color-dark text-[14px] mb-0">
              Employee Management
            </h2>
            <span className="text-gray-400 text-[12px]">
              Manage your employees here
            </span>
          </div>
        </div>
      </div>
      <div className="pageBody-inner p-6">
        <div className="kr-block">
          <div className="card !border-none">
            <div className="card-inner p-0">
              <div className="kr-table-header border-bottom px-6 py-3  ">
                <div className="w-100 flex items-center mb-lg-0 justify-between">
                  {/* Filter Panel */}
                  <div className="flex gap-2 items-center relative">
                    <button
                      type="button"
                      className="flex items-center gap-2 px-3 py-[6px] btn-light border border-solid border-gray-200 rounded text-[12px] font-semibold"
                      onClick={() => setShowFilterPanel((prev) => !prev)}
                    >
                      <svg width="12" viewBox="0 0 700 700" fill="currentColor">
                        <path d="M618.3,89.7H81.7c-16,0-30.7,8.5-38.7,22.4c-8,13.8-8,30.9,0,44.7c8,13.8,22.8,22.4,38.7,22.4h536.6c16,0,30.7-8.5,38.7-22.4c8-13.8,8-30.9,0-44.7C649,98.2,634.3,89.7,618.3,89.7z M528.9,313.3H171.1c-16,0-30.7,8.5-38.7,22.4c-8,13.8-8,30.9,0,44.7c8,13.8,22.8,22.4,38.7,22.4h357.7c16,0,30.7-8.5,38.7-22.4c8-13.8,8-30.9,0-44.7C559.6,321.8,544.8,313.3,528.9,313.3z M439.4,536.9H260.6c-16,0-30.7,8.5-38.7,22.4c-8,13.8-8,30.9,0,44.7c8,13.8,22.7,22.4,38.7,22.4h178.9c16,0,30.7-8.5,38.7-22.4c8-13.8,8-30.9,0-44.7C470.2,545.4,455.4,536.9,439.4,536.9z" />
                      </svg>
                      Filter
                    </button>

                    {showFilterPanel && (
                      <>
                        <div className="fixed inset-0 z-40" onClick={() => setShowFilterPanel(false)} />
                        <div className="absolute top-[38px] left-0 z-50 bg-white border border-gray-200 rounded-lg shadow-xl w-[450px] p-4 flex flex-col gap-2">
                          <div>
                            <label className="kr-form-label mb-1 block text-[12px]">Department</label>

                            <Select
                              searchable={false}
                              backspaceDelete={false}
                              placeholder="Select Department"
                              values={filterValue.department?.value ? [filterValue.department] : []}
                              className="form-control kr-form-textbox"
                              options={filterDropdowns.departments.map((d) => ({
                                value: d.departmentName,
                                label: d.departmentName,
                              }))}
                              onChange={(sel) =>
                                setFilterValue((prev) => ({
                                  ...prev,
                                  department: { value: sel?.[0]?.value ?? null, label: sel?.[0]?.label ?? "" },
                                }))
                              }
                            />
                          </div>
                          <div>
                            <label className="kr-form-label mb-1 block text-[12px]">Designation</label>
                            <Select
                              searchable={false}
                              backspaceDelete={false}
                              placeholder="Select Designation"
                              values={filterValue.designation?.value ? [filterValue.designation] : []}
                              className="form-control kr-form-textbox"
                              options={filterDropdowns.designations.map((d) => ({
                                value: d.designationName,
                                label: d.designationName,
                              }))}
                              onChange={(sel) =>
                                setFilterValue((prev) => ({
                                  ...prev,
                                  designation: { value: sel?.[0]?.value ?? null, label: sel?.[0]?.label ?? "" },
                                }))
                              }
                            />
                          </div>
                          <div className="flex gap-2 pt-2 border-t border-gray-100 justify-end">
                            <button
                              type="button"
                              className="flex items-center justify-center py-[6px] px-[12px] btn-light border border-solid border-gray-200 rounded text-[12px]"
                              onClick={() => {
                                const reset = { value: null, label: "" };
                                setFilterValue({ department: reset, designation: reset });
                              }}
                            >
                              Clear
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary flex items-center justify-center py-[6px] px-[12px] text-[12px]"
                              onClick={() => {
                                getUsers(
                                  filterValue.department.value ? filterValue.department.label : null,
                                  filterValue.designation.value ? filterValue.designation.label : null,
                                );
                                setShowFilterPanel(false);
                              }}
                            >
                              Apply
                            </button>
                          </div>
                        </div>
                      </>
                    )}
                  </div>

                  {/* Search + Add */}
                  <div className="flex h-[32px] gap-2">
                    <div className="flex place-content-center user-search-filter-parent sm:w-[200px]">
                      <input
                        onChange={(e) => {
                          handleSearch(e.target.value);
                          setSearchFilter(e.target.value);
                        }}
                        type="text"
                        value={searchFilter}
                        placeholder="Search..."
                        className="user-search-filter-input"
                      />
                    </div>
                    <button
                      type="submit"
                      className="btn btn-primary flex justify-center items-center min-w-80"
                      onClick={() => handleSidebarOpen("add", null)}
                    >
                      Add
                    </button>
                  </div>
                </div>
              </div>

              <div className="kr-block px-3 pt-2 pb-3">
                <div className="overflow-x-auto">
                  {loading ? (
                    displayedData?.length > 0 ? (
                      <table className="table kr-table-striped">
                        <thead>
                          <tr>
                            <th className="text-center">#</th>
                            <th>Employee Id</th>
                            <th>Employee Name</th>
                            <th>Designation</th>
                            <th>Department</th>
                            <th>Email</th>
                            <th className="min-w-[100px]">Assigned Assets</th>
                            {/* <th>Assets</th> */}
                          </tr>
                        </thead>
                        <tbody>
                          {displayedData?.map((data, index) => (
                            <tr className="relative" key={index}>
                              <td className="whitespace-nowrap text-center">
                                {startIndex + index + 1}
                              </td>
                              <td className="uppercase whitespace-nowrap">
                                {data.empid}
                              </td>
                              <td className="uppercase whitespace-nowrap">
                                {data.username}
                              </td>
                              <td className="uppercase whitespace-nowrap">
                                {data.designation}
                              </td>
                              <td className="uppercase whitespace-nowrap">
                                {data.department}
                              </td>
                              <td className="uppercase whitespace-nowrap">
                                {data.email}
                              </td>
                              <td className="whitespace-nowrap overflow-visible min-w-[220px]">
                                {renderAssetIcons(data.assignedasset)}
                              </td>

                              {/* <td className='uppercase whitespace-nowrap'>{data.monitor1?.length>3&&data.monitor2?.length>3?"2":data.monitor1?.length>3||data.monitor2?.length>3?"1":"0"}</td> */}
                              <td className="kr-tbl-action">
                                <div className="flex justify-end shrink-0">
                                  <ul>
                                    <li>
                                      {" "}
                                      <ViewAsset data={data} />
                                    </li>
                                    <li>
                                      <Tooltip
                                        title="Edit"
                                        placement="top"
                                        arrow
                                        leaveDelay={50}
                                      >
                                        {/* <OverlayTrigger key={data.id} placement="top" overlay={renderTooltip({ tooltiptext: "Edit" })}> */}
                                        <div
                                          className="kr-tbl-edit cursor-pointer action-item"
                                          onClick={() => {
                                            handleSidebarOpen("edit", data);
                                          }}
                                        >
                                          <span className="svg-icon">
                                            <svg
                                              x="0px"
                                              y="0px"
                                              viewBox="0 0 700 700"
                                            >
                                              <g>
                                                <path
                                                  d="M631.3,133.8l-80-80C539.9,42.5,524.6,36,508.4,36c-16.2,0-31.5,6.5-42.8,17.8L117.1,402.2c-7.3,7.3-12.1,16.2-15.4,25.9
                         l-49.3,169c-3.2,9.7,0,20.2,7.3,28.3c5.7,5.7,12.9,8.1,20.2,8.1c2.4,0,5.7,0,8.1-0.8l169-49.3c9.7-3.2,18.6-8.1,25.9-15.4
                         l348.4-348.4c11.3-11.3,17.8-26.7,17.8-42.8C649.1,160.5,642.6,145.1,631.3,133.8L631.3,133.8z M147,475l63.1,63.1l-88.9,25.9
                         L147,475z M590.9,179.9l-55,55l-85.7-85.7l55-55c0.8-0.8,2.4-0.8,3.2-0.8c0.8,0,1.6,0,3.2,0.8l80,80c0.8,0.8,0.8,2.4,0.8,3.2
                         C592.5,178.3,591.7,179.1,590.9,179.9z"
                                                ></path>
                                              </g>
                                            </svg>
                                          </span>
                                        </div>
                                      </Tooltip>
                                      {/* </OverlayTrigger> */}
                                    </li>
                                    <li>
                                      <Tooltip
                                        title="Delete"
                                        placement="top"
                                        arrow
                                        leaveDelay={50}
                                      >
                                        {/* <OverlayTrigger key={data.id} placement="top" overlay={renderTooltip({ tooltiptext: "Delete" })}> */}
                                        <div
                                          className="kr-tbl-delete cursor-pointer action-item"
                                          onClick={() => {
                                            deleteUser(data);
                                          }}
                                        >
                                          <span className="svg-icon">
                                            <svg
                                              x="0px"
                                              y="0px"
                                              viewBox="0 0 700 700"
                                            >
                                              <g>
                                                <path
                                                  d="M598.3,144.5H475.1v-26.9c0-19-17.4-33-39.2-33H297.6c-21.8,0-39.2,14.6-39.2,33v26.9H135.7c-12.3,0-21.8,9.5-21.8,21.8
                           c0,12.3,9.5,21.8,21.8,21.8h26.9l26.9,336.6c0.6,39.8,32.5,71.7,72.2,71.7h210c39.8,0,71.7-31.9,72.2-71.7l27.4-336h26.9
                           c12.3,0,21.8-9.5,21.8-21.8C620.1,154.6,610.6,144.5,598.3,144.5L598.3,144.5z M302,127.7H432v16.8l-129.9,0V127.7z M310.4,479.4
                           h-0.6c-11.8,0-20.7-9.5-21.8-20.7l-7.8-176.4c-0.6-12.3,8.4-22.4,20.7-22.4h0.6c11.8,0,20.7,9.5,21.8,20.7l7.8,176.4
                           C331.7,468.7,322.8,478.8,310.4,479.4L310.4,479.4z M446,458.1c-0.6,11.8-10.1,20.7-21.8,20.7h-0.6c-12.3-0.6-20.7-10.6-20.7-22.4
                           l7.8-176.4c0.6-11.8,10.1-20.7,21.8-20.7h0.6c12.3,0.6,20.7,10.6,20.7,22.4L446,458.1z"
                                                ></path>
                                              </g>
                                            </svg>
                                          </span>
                                        </div>
                                      </Tooltip>
                                      {/* </OverlayTrigger> */}
                                    </li>
                                  </ul>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    ) : (
                      <div className="flex flex-col items-center justify-center gap-2 py-10">
                        <img
                          src={NoDataFoundImage}
                          alt="No Data Found"
                          className="w-[120px] h-[120px] opacity-80"
                        />
                        <span className="text-gray-500 text-[13px] font-semibold">
                          No Data Found
                        </span>
                      </div>
                    )
                  ) : (
                    <div className="w-100 flex justify-center items-center py-6 bg-light">
                      <div className="kr-pageLoader">
                        <span className="loader"></span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              {displayedData?.length > 0 && (
                <div className="kr-block pt-3 pb-3 font-size-12px color-gray border-top px-3">
                  <nav className="w-full position:relative m-0">
                    <ul className="list-none ml-0 mb-0 pagination">
                      <li
                        className={`inline-block pagination-prev cursor-pointer ${currentPage === 1 ? "disabled" : ""
                          }`}
                        onClick={goToPreviousPage}
                      >
                        <span>Previous</span>
                      </li>
                      {renderPageNumbers()}
                      <li
                        className={`inline-block pagination-next cursor-pointer ${endIndex >= data?.length ? "disabled" : ""
                          }`}
                        onClick={goToNextPage}
                      >
                        <span>Next</span>
                      </li>
                    </ul>
                  </nav>
                </div>
              )}
            </div>

          </div>
        </div>
      </div>

      <div
        className={`kr-popup-overlay ${isSidebarOpen ? "kr-side-popup-overlay" : ""
          }`}
      ></div>
      <div
        className={`kr-side-popup ${isSidebarOpen ? "kr-side-popup-on !w-[90vw] md:!w-[400px]" : ""
          }`}
      >
        <div className="kr-block w-100">
          <div className="flex items-center py-[16px] px-6 bg-gray-50">
            <div className="pl-2">
              <h2 className="font-bold color-dark text-[14px] mb-0">
                {sidebarAction === "add" ? "Add User" : "Update User"}
              </h2>
              <span className="text-gray-400 text-[12px]">
                {sidebarAction === "add"
                  ? "Add new user"
                  : "Update user details"}
              </span>
            </div>
          </div>
          <div className="kr-block p-4">
            <div id="form">
              <div className="grid grid-cols-1 gap-1 ">
                <div className="">
                  <div className="kr-selectform required">
                    <label className="kr-form-label">Employee ID</label>
                    <input
                      type="text"
                      placeholder="Enter Employee ID"
                      value={selectedValue?.empid?.label}
                      maxLength={50}
                      className={`form-control kr-form-textbox placeholder-[#9ca3af]    ${dataError.empid === false ? "" : "dataError"
                        }`}
                      onChange={(e) => handleInputChange(e, "empid")}
                      readOnly={sidebarAction === "edit"}
                    ></input>
                  </div>
                </div>
                <div className="">
                  <div className="kr-selectform required">
                    <label className="kr-form-label">Employee Name</label>
                    <input
                      type="text"
                      placeholder="Enter Employee Name"
                      value={selectedValue?.username?.label}
                      maxLength={50}
                      className={`form-control kr-form-textbox placeholder-[#9ca3af]  ${dataError.username === false ? "" : "dataError"
                        }`}
                      onChange={(e) => handleInputChange(e, "username")}
                    ></input>
                  </div>
                </div>

                <div className="">
                  <div className="kr-selectform required">
                    <label className="kr-form-label">Department</label>

                    <Select
                      placeholder="Select Department"
                      values={
                        selectedValue?.department?.value
                          ? [selectedValue.department]
                          : []
                      }
                      options={filterDropdowns.departments.map((d) => ({
                        value: d.departmentName,
                        label: d.departmentName,
                      }))}
                      onChange={(selectedOption) => {
                        handleInputChange(selectedOption, "department");
                      }}
                      name="department"
                      className={`w-100 ${dataError?.department === false ? "" : "dataError"}`}
                    />
                  </div>
                </div>

                <div className="">
                  <div className="kr-selectform required">
                    <label className="kr-form-label">Designation</label>
                    <Select
                      placeholder="Select Designation"
                      values={
                        selectedValue?.designation?.value
                          ? [selectedValue.designation]
                          : []
                      }
                      options={filterDropdowns.designations.map((d) => ({
                        value: d.designationName,
                        label: d.designationName,
                      }))}
                      onChange={(selectedOption) => {
                        handleInputChange(selectedOption, "designation");
                      }}
                      name="designation"
                      className={`w-100 ${dataError?.designation === false ? "" : "dataError"}`}
                    />
                  </div>
                </div>

                <div className="">
                  <div className="kr-selectform required">
                    <label className="kr-form-label">Email ID</label>
                    <input
                      type="email"
                      placeholder="Enter Email ID"
                      value={selectedValue?.email?.label}
                      className={`form-control kr-form-textbox placeholder-[#9ca3af]  ${dataError.email === false ? "" : "dataError"
                        }`}
                      onChange={(e) => handleInputChange(e, "email")}
                    ></input>
                  </div>
                </div>
              </div>

              <div className=" mt-3">
                <div className="">
                  <div className="form-group flex justify-end">
                    {/* <Link to ='/' className='no-underline'> */}
                    <button
                      type="button"
                      className="flex items-center justify-center py-[6px] px-[12px] btn-light border border-solid border-gray-200 rounded min-w-80"
                      onClick={handleSidebarClose}
                    >
                      Cancel
                    </button>
                    {/* </Link> */}
                    {/* <Link to ='/' className='no-underline'> */}
                    <button
                      type="button"
                      className="btn btn-primary flex items-center justify-center ml-2 min-w-80"
                      onClick={handleSidebarFormSubmit}
                    >
                      {sidebarAction === "add" ? "Add" : "Update"}
                    </button>
                    {/* </Link> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <ToastContainer transition={Slide} /> */}
    </>
  );
}

export default UserManagement;
